export default __webpack_public_path__ + "static/URWDIN-Regular-f9d8689a8855d967675757e2e8810167.woff";